import { render, staticRenderFns } from "./LenderPayoutTable.vue?vue&type=template&id=b877615a&"
import script from "./LenderPayoutTable.vue?vue&type=script&lang=js&"
export * from "./LenderPayoutTable.vue?vue&type=script&lang=js&"
import style0 from "./LenderPayoutTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports